import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

export default function SearchField({ searchQuery, setSearchQuery }) {
  const navigate = useNavigate();
  const [localQuery, setLocalQuery] = useState("");
  const value = searchQuery ?? localQuery;
  const onChange = setSearchQuery ?? setLocalQuery;
  const submitSearch = () => {
    const q = String(value || "").trim();
    if (q) navigate(`/search?q=${encodeURIComponent(q)}`);
  };
  return (
    <div className="w-full min-w-0 flex items-center bg-gray-100 rounded-2xl px-3 py-2 transition-all focus-within:bg-white focus-within:ring-2 focus-within:ring-orange-500/20">
      <FiSearch className="text-gray-400 mr-2 shrink-0" size={18} />
      <input
        type="text"
        aria-label="Search Recettes"
        placeholder="Search Recettes..."
        className="bg-transparent outline-none w-full min-w-0 text-sm font-medium text-gray-800"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") submitSearch(); }}
      />
    </div>
  );
}
